export default __webpack_public_path__ + "media/zurb/img/ecommerce/jab_2-135f50e6e2e2acd9dbaba1270139a505.png";